import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { InspectionService } from '../../../inspection/inspection.service';
import { SentEmail, ProductType } from '../../interfaces';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { escapeHtml } from '../../html.helper';

@Component({
  selector: 'app-view-email-modal',
  templateUrl: './view-email-modal.component.html',
  styleUrls: ['./view-email-modal.component.scss'],
})
export class ViewEmailModalComponent implements OnInit {
  @ViewChild('sendEmailModal') sendEmailModal: BsModalRef;
  EmailSent: SentEmail;
  id: number;
  letterEmail: SentEmail;
  productType: ProductType;
  emailContent: SafeHtml = '';
  loading = false;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  public primaryColour = '#ffffff';
  public secondaryColour = '#ccc';

  constructor(
    private inspectionService: InspectionService,
    private sanitizer: DomSanitizer,
    public modalRef: BsModalRef,
  ) {}

  ngOnInit(): void {
    this.loading = true;
    if (!this.letterEmail) {
      this.inspectionService.getSentEmailById(this.id).then(res => {
        this.EmailSent = res;
        this.emailContent = this.toSafeEmailBodyHtml(this.EmailSent.body, 'plain');
        this.loading = false;
      });
    } else {
      this.EmailSent = this.letterEmail;
      // Rec-letter history (flag manager / full review): render stored HTML like pre–AI-4870.
      this.emailContent = this.toSafeEmailBodyHtml(this.letterEmail.body, 'trusted-html');
      this.loading = false;
    }
  }

  /**
   * trusted-html: rec-letter sent emails — full template HTML (styles/layout) as before AI-4870.
   * plain: inspection changelog “Preview Email” by id — escape user-controlled markup (XSS fix).
   */
  private toSafeEmailBodyHtml(body: string | null | undefined, mode: 'plain' | 'trusted-html'): SafeHtml {
    const raw = body ?? '';
    if (mode === 'trusted-html') {
      return this.sanitizer.bypassSecurityTrustHtml(raw);
    }
    const escaped = escapeHtml(raw);
    const withLineBreaks = escaped.replace(/\r\n/g, '\n').replace(/\n/g, '<br>');
    return this.sanitizer.bypassSecurityTrustHtml(withLineBreaks);
  }
  closeModal() {
    this.modalRef.hide();
  }

  async downloadEmail(letterEmail: SentEmail) {
    this.inspectionService.downloadSentEmail(letterEmail.id).then(data => {
      const blob = new Blob([data as any], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'RecLetterEmail.pdf';
      link.click();
      window.URL.revokeObjectURL(url);
    });
  }
}
